import React from 'react'
import { ArrowClockwise, Laptop, Pencil, Phone, PhoneFill, Robot, Search, CloudDownload,
  Gear, Shield, Envelope, Cloud, Apple, Android, Bell, Hdd, ChatDots, Cpu, ArrowRepeat, Pen, BarChart, Cart
} from "react-bootstrap-icons";
import websites from "../assets/websites.png"
import smartphone from "../assets/smartphone.png"
import ai from "../assets/ai.png"
import { Link } from 'react-router-dom';

export default function Services() {
  const [activeService, setActiveService] = React.useState(null);

  const handleCardClick = (serviceKey) => {
    setActiveService(serviceKey);
  };

  const handleBack = () => {
    setActiveService(null);
  };

  const renderExpandedServiceContent = () => {
    if (activeService === "web") {
      return (
        <>
          <h3 className="fw-bold mb-3">Websites</h3>

          <div className="d-flex justify-content-center mb-3">
            <img src={websites} className="w-75" alt="Websites concept" />
          </div>

          <p className="text-muted mb-4">
            Fast, modern and reliable websites built to support your business and give visitors
            a clean and effortless experience.
          </p>

          <div className="row g-3">

            {/* Left column: Features */}
            <div className="col-md-6">
              <div className="custom-card-light rounded p-3 mx-2">
                <h5 className="fw-semibold mb-3">Features</h5>

                <div className="d-flex align-items-center mb-2">
                  <Pencil size={25} className="me-2 brand-dark-purple" />
                  <span>Modern, accessible designs</span>
                </div>

                <div className="d-flex align-items-center mb-2">
                  <Search size={25} className="me-2 brand-dark-purple" />
                  <span>Optimised for search engines</span>
                </div>

                <div className="d-flex align-items-center">
                  <ArrowClockwise size={25} className="me-2 brand-dark-purple" />
                  <span>Easy to update and maintain</span>
                </div>
              </div>
            </div>

            {/* Right column: Included */}
            <div className="col-md-6">
              <div className="custom-card-light rounded p-3 mx-2">
                <h5 className="fw-semibold mb-3">Can Include</h5>

                <div className="d-flex align-items-center mb-2">
                  <Phone size={25} className="me-2 brand-dark-purple" />
                  <span>Responsive for mobile and tablet</span>
                </div>

                <div className="d-flex align-items-center mb-2">
                  <Shield size={25} className="me-2 brand-dark-purple" />
                  <span>Security and performance setup</span>
                </div>

                <div className="d-flex align-items-center mb-2">
                  <Envelope size={25} className="me-2 brand-dark-purple" />
                  <span>Contact forms and email alerts</span>
                </div>

                <div className="d-flex align-items-center">
                  <Cloud size={25} className="me-2 brand-dark-purple" />
                  <span>Hosting support available</span>
                </div>
              </div>
            </div>

          </div>

          {/* CTA Section */}
          <div className="mt-4">
            <p className="text-muted mb-3">
              To proceed with having a website built, simply fill in the short form with your
              concept and your details. I will review everything and get in touch to discuss
              your idea and the next steps.
            </p>
            <Link to={"/concept"} className="btn brand-purple-inline">Start</Link>
          </div>
        </>
      );
    }

    if (activeService === "mobile") {
      return (
        <>
          <h3 className="fw-bold mb-3">Progressive Web Apps</h3>

          <div className="d-flex justify-content-center mb-3">
            <img src={smartphone} className="w-25" alt="Web app concept" />
          </div>

          <p className="text-muted mb-4">
            Installable web apps that run in the browser on phone, tablet and desktop. 
            Fast, efficient and built to feel natural on every device.
          </p>

          <div className="row g-3">

            {/* Left column: Features */}
            <div className="col-md-6">
              <div className="custom-card-light rounded p-3 mx-2">
                <h5 className="fw-semibold mb-3">Features</h5>

                <div className="d-flex align-items-center mb-2">
                  <PhoneFill size={25} className="me-2 brand-dark-purple" />
                  <span>Feels like a native app on phone and tablet</span>
                </div>

                <div className="d-flex align-items-center mb-2">
                  <CloudDownload size={25} className="me-2 brand-dark-purple" />
                  <span>Works offline where needed</span>
                </div>

                <div className="d-flex align-items-center">
                  <Gear size={25} className="me-2 brand-dark-purple" />
                  <span>Back end and API integration</span>
                </div>
              </div>
            </div>

            {/* Right column: Can Include */}
            <div className="col-md-6">
              <div className="custom-card-light rounded p-3 mx-2">
                <h5 className="fw-semibold mb-3">Can Include</h5>

                <div className="d-flex align-items-center mb-2">
                  <Apple size={25} className="me-2 brand-dark-purple" />
                  <span>Add to home screen on iPhone and iPad</span>
                </div>

                <div className="d-flex align-items-center mb-2">
                  <Android size={25} className="me-2 brand-dark-purple" />
                  <span>Add to home screen on Android devices</span>
                </div>

                <div className="d-flex align-items-center mb-2">
                  <Bell size={25} className="me-2 brand-dark-purple" />
                  <span>Push notifications where supported</span>
                </div>

                <div className="d-flex align-items-center">
                  <Hdd size={25} className="me-2 brand-dark-purple" />
                  <span>Secure cloud storage options</span>
                </div>
              </div>
            </div>

          </div>

          {/* CTA Section */}
          <div className="mt-4">
            <p className="text-muted mb-3">
              To get started, simply fill in the short form with your app concept and your
              details. I will review everything and get in touch to discuss your idea and the
              next steps.
            </p>

            <Link to={"/concept"} className="btn brand-purple-inline">Start</Link>
          </div>
        </>
      );
    }

    if (activeService === "ai") {
      return (
        <>
          <h3 className="fw-bold mb-3">AI Integration</h3>

          <div className="d-flex justify-content-center mb-3">
            <img src={ai} className="w-75" alt="AI concept" />
          </div>

          <p className="text-muted mb-4">
            Enhance what you already have by layering powerful AI features on top, no need to
            rebuild your entire system.
          </p>

          <div className="row g-3">

            {/* Left column: Features */}
            <div className="col-md-6">
              <div className="custom-card-light rounded p-3 mx-2">
                <h5 className="fw-semibold mb-3">Features</h5>

                <div className="d-flex align-items-center mb-2">
                  <ChatDots size={25} className="me-2 brand-dark-purple" />
                  <span>Chat assistants for your site or app</span>
                </div>

                <div className="d-flex align-items-center mb-2">
                  <Cpu size={25} className="me-2 brand-dark-purple" />
                  <span>Content and data processing tools</span>
                </div>

                <div className="d-flex align-items-center">
                  <ArrowRepeat size={25} className="me-2 brand-dark-purple" />
                  <span>Workflows that save real time and effort</span>
                </div>
              </div>
            </div>

            {/* Right column: Can Include */}
            <div className="col-md-6">
              <div className="custom-card-light rounded p-3 mx-2">
                <h5 className="fw-serif mb-3">Can Include</h5>

                <div className="d-flex align-items-center mb-2">
                  <Pen size={25} className="me-2 brand-dark-purple" />
                  <span>Content generation</span>
                </div>

                <div className="d-flex align-items-center mb-2">
                  <BarChart size={25} className="me-2 brand-dark-purple" />
                  <span>Data analysis and insights</span>
                </div>

                <div className="d-flex align-items-center mb-2">
                  <Cart size={25} className="me-2 brand-dark-purple" />
                  <span>Smart product recommendations</span>
                </div>

                <div className="d-flex align-items-center">
                  <Search size={25} className="me-2 brand-dark-purple" />
                  <span>Improved website findability</span>
                </div>
              </div>
            </div>

          </div>

          {/* CTA Section */}
          <div className="mt-4">
            <p className="text-muted mb-3">
              To proceed with exploring AI integration, simply fill in the short form with your
              concept and your details. I will review everything and get in touch to discuss
              your idea and the next steps.
            </p>

            <Link to={"/concept"} className="btn brand-purple-inline">Start</Link>
          </div>
        </>
      );
    }

    return null;
  };

  return (
    <div>
      <h2 className="text-center fw-bold mb-3">Services</h2>

      {/* Normal grid view */}
      {!activeService && (
        <div className="row g-4">
          {/* Websites */}
          <div className="col-md-4">
            <div
              className="custom-card p-4 rounded-4 shadow-sm h-100"
              role="button"
              onClick={() => handleCardClick("web")}
            >
              <div className="icon-circle">
                <Laptop />
              </div>
              <h4 className="fw-bold mt-3">Websites</h4>
              <p className="text-muted">
                Clean, fast, responsive websites that look great on every device.
              </p>
            </div>
          </div>

          {/* Progressive Web Apps */}
          <div className="col-md-4">
            <div
              className="custom-card p-4 rounded-4 shadow-sm h-100"
              role="button"
              onClick={() => handleCardClick("mobile")}
            >
              <div className="icon-circle">
                <Phone />
              </div>
              <h4 className="fw-bold mt-3">Progressive Web Apps</h4>
              <p className="text-muted">
                Installable web apps that work on mobile and desktop.
              </p>
            </div>
          </div>

          {/* AI */}
          <div className="col-md-4">
            <div
              className="custom-card p-4 rounded-4 shadow-sm h-100"
              role="button"
              onClick={() => handleCardClick("ai")}
            >
              <div className="icon-circle">
                <Robot />
              </div>
              <h4 className="fw-bold mt-3">AI Integration</h4>
              <p className="text-muted">
                Adding AI features to existing websites and apps.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Expanded view inside main div */}
      {activeService && (
        <div className="mt-3">
          {/* Icon bar top left */}
          <div className="d-flex align-items-center mb-3">
            <button
              type="button"
              className={
                "btn me-2 d-flex align-items-center justify-content-center rounded-circle" +
                (activeService === "web" ? " btn-dark" : " btn-outline-dark")
              }
              onClick={() => setActiveService("web")}
            >
              <Laptop />
            </button>
            <button
              type="button"
              className={
                "btn me-2 d-flex align-items-center justify-content-center rounded-circle" +
                (activeService === "mobile" ? " btn-dark" : " btn-outline-dark")
              }
              onClick={() => setActiveService("mobile")}
            >
              <Phone />
            </button>
            <button
              type="button"
              className={
                "btn d-flex align-items-center justify-content-center rounded-circle" +
                (activeService === "ai" ? " btn-dark" : " btn-outline-dark")
              }
              onClick={() => setActiveService("ai")}
            >
              <Robot />
            </button>

            <button
              type="button"
              className="btn btn-link ms-3 text-decoration-none"
              onClick={handleBack}
            >
              Back
            </button>
          </div>

          {/* Expanded card fills the section width */}
          <div className="custom-card p-4 rounded-4 shadow-sm">
            {renderExpandedServiceContent()}
          </div>
        </div>
      )}
    </div>
  );
}
